<template>
  <b-container>
    <b-form-radio-group v-model="defined_manually" stacked>
      <b-form-radio :value="false">{{ $t('api') }}</b-form-radio>
      <template v-if="!defined_manually">
        <b-form-radio-group v-model="synchronous" class="ml-3 mt-2" stacked>
          <b-form-radio :value="false">{{ $t('asynchronous') }}</b-form-radio>
          <b-form-radio :value="true">{{ $t('synchronous') }}</b-form-radio>
        </b-form-radio-group>
        <b-form-group class="ml-3 mt-2" :label="$t('endpoint') + ':'">
          <b-form-input v-model="endpoint" :disabled="changes_disabled" />
        </b-form-group>
      </template>

      <b-form-radio :value="true">{{ $t('manual_json') }}</b-form-radio>
      <b-form-group v-if="defined_manually" class="ml-3 mt-2">
        <!-- <code-editor v-model="manual_json" :disabled="changes_disabled" /> -->
        <togglable-code-editor
          v-model="manual_json"
          :disabled="changes_disabled"
        />
      </b-form-group>
    </b-form-radio-group>
    <h2 class="my-5">
      <b>{{ $t('json_schema') }}</b>
    </h2>
    <togglable-code-editor v-model="json_schema" />
  </b-container>
</template>

<i18n>
{
  "en": {
    "manual_json": "Manually defined Json",
    "api": "Api",
    "input": "Input",
    "json_schema": "JSON Schema"
  },
  "fr": {
    "manual_json": "Objet Json défini manuellement",
    "api": "Api",
    "input": "Entrée",
    "json_schema": "JSON Schéma"
  }
}
</i18n>

<script>
import _ from 'lodash'

// import CodeEditor from '@/components/code_editor.vue'
import TogglableCodeEditor from '@/components/togglable_code_editor.vue'

import ColumnsChoiceOptions from './columns_choice_options.vue'
import GenericColumnNameEditionForCoercion from './generic_column_name_edition_for_coercion.vue'
import { GenericColumnNameForCoercion } from '@/components/object_model.js'

// import { subscription_mixin, brick_mixin } from '@/components/mixin.js'
import { global_brick_mixin } from '@/components/mixin.js'

// *****************************************************************************

export default {
  name: 'BrickApiInput',
  components: {
    // CodeEditor,
    TogglableCodeEditor,
    ColumnsChoiceOptions,
    GenericColumnNameForCoercion,
    GenericColumnNameEditionForCoercion,
  },
  // mixins: [subscription_mixin, brick_mixin],
  mixins: [global_brick_mixin],
  // props: [
  //   'brick_id',
  //   'project_id',
  //   'description_name',
  //   'metavariables_dicts_poids',
  // ],
  data() {
    return {
      defined_manually: true,
      endpoint: '',
      synchronous: false,
      // manual_json: '',
      manual_json: undefined,
      json_schema: '',
      // default_json: encodeURI({
      //   prospects: { client_id: 1, last_contact_dt: '' },
      //   mailing: [
      //     {
      //       mailing_id: 0,
      //       client_id: '1',
      //       result: 0,
      //       job: 'director',
      //       last_contact_dt: '18/12/2016',
      //     },
      //     {
      //       mailing_id: 1,
      //       client_id: '3',
      //       result: 0,
      //       job: 'assistant',
      //       last_contact_dt: '25/09/2012',
      //     },
      //   ],
      // }),
    }
  },
  computed: {
    // generic_column_name_for_coercion_constructor() {
    //   return GenericColumnNameForCoercion
    // },
    adapted_data() {
      let adapted = {
        uid: this.brick_id,
        defined_manually: this.defined_manually,
        endpoint: this.endpoint,
        synchronous: this.synchronous,
        manual_json: this.manual_json,
        json_schema: this.json_schema,
      }

      _.assignIn(adapted, this.description_name)

      return adapted
    },
  },
  watch: {
    cur_brick: {
      immediate: true,
      handler(nv) {
        this.defined_manually = nv.defined_manually
        this.endpoint = nv.endpoint
        this.synchronous = nv.synchronous
        this.manual_json = nv.manual_json
        this.json_schema = nv.json_schema
      },
    },
  },
}
</script>
